import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface ClearSearchButtonProps {
  onClick: () => void;
}

export const ClearSearchButton: React.FC<ClearSearchButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <button
      className="flex items-center gap-2 whitespace-nowrap rounded-full bg-rw-red px-2 py-1 font-medium text-white shadow-lg transition-all duration-200 hover:bg-rw-main hover:shadow-xl"
      onClick={() => {
        onClick();
      }}
      title={t('検索結果をクリア')}
    >
      <XMarkIcon className="size-4" />
      <span className="text-xs">{t('検索結果をクリア')}</span>
    </button>
  );
};
